import { Box } from '@mui/material';
import { userDetailsWrapper } from '../../../../shared/lib/theme/styleConstants';
import { EditAccountName } from './EditAccountName';
import { EditUserContactNumber } from './EditUserContactNumber';
import { EditUserEmail } from './EditUserEmail';
import { DeActiveAccount } from './DeactiveAccount';
import { SocialSource } from './SocialSource';
import { ChangeUserPassword } from './ChangeUserPassword';

export const AccountDetails = () => (
  <Box marginTop="16px">
    <Box sx={userDetailsWrapper} marginBottom="24px">
      <EditAccountName />

      <EditUserEmail />

      <EditUserContactNumber />

      <SocialSource />

      <ChangeUserPassword />
    </Box>

    <Box sx={{ ...userDetailsWrapper, marginBottom: '16px' }}>
      <DeActiveAccount />
    </Box>
  </Box>
);
